import { Text, Editor } from 'slate';

function isBlock(editor, node) {
  return !Text.isText(node) && Editor.isBlock(editor, node);
}

export { isBlock };
